export const operationProcedureOptions = [
  "Appendectomy", "Cholecystectomy", "Hernia Repair", "Coronary Artery Bypass", "Knee Replacement",
  "Cataract Surgery", "Hip Replacement", "Tonsillectomy", "Gallbladder Removal", "Carpal Tunnel Release",
  "Spinal Fusion", "Heart Valve Repair", "Mastectomy", "Thyroidectomy", "Cesarean Section",
  "Prostatectomy", "Hysterectomy", "Laparoscopy", "Angioplasty", "Pacemaker Implantation",
  "Nephrectomy", "Colectomy", "Bariatric Surgery", "Liver Transplant", "Kidney Transplant"
];

export const unableConsentReasons = [
  "Patient unconscious", "Patient sedated", "Cognitive impairment", "Severe pain or distress",
  "Emergency situation", "Language barrier", "Hearing impairment", "Developmental disability",
  "Under influence of medication or substances",
];

export const diagnosisTests = ['Blood test', 'MRI scan', 'CT scan', 'X-ray', 'ECG', 'Ultrasound', 'Biopsy', 'Urinalysis'];
export const diagnoses = ['Hypertension', 'Diabetes mellitus', 'Pneumonia', 'Stroke', 'Chronic Kidney Disease', 'COVID-19'];
export const conditionOptions = [
  'Improvement in breathing', 'Worsening of fever', 'Increased pain', 'Seizure',
  'Blood pressure fluctuation', 'Reduced mobility', 'Loss of consciousness', 'Stable vitals',
];

export const majorRiskOptions = [
  "Bleeding", "Infection", "Blood clots", "Organ damage", "Anesthesia complications",
  "Nerve damage", "Heart attack", "Stroke", "Allergic reaction", "Death",
  "Pneumonia", "Sepsis", "Pulmonary embolism", "Deep vein thrombosis", "Wound dehiscence",
  "Respiratory failure", "Myocardial infarction", "Hemorrhage", "Renal failure", "Shock",
  "Hypoxia", "Aspiration", "Edema", "Arrhythmia", "Neurological deficit",
  "Thrombophlebitis", "Postoperative delirium", "Surgical site infection",
  "Acute respiratory distress syndrome", "Cardiac arrest", "Hypotension", "Hyperthermia",
  "Electrolyte imbalance", "Gastrointestinal bleeding", "Urinary tract infection", "Anaphylaxis",
];

export const doctorGroups = {
  Cardiologists: ["Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown", "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"],
  Neurologists: ["Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson", "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"],
  Orthopedics: ["Dr. Richard Garcia", "Dr. Jennifer Harris", "Dr. Charles Clark", "Dr. Jessica Lewis", "Dr. Thomas Robinson", "Dr. Karen Walker"],
  Dermatologists: ["Dr. Nancy Young", "Dr. Matthew Hall", "Dr. Donna Allen", "Dr. Steven King", "Dr. Michelle Wright", "Dr. George Scott"],
  Gynecologists: ["Dr. Sandra Green", "Dr. Kevin Adams", "Dr. Laura Baker", "Dr. Mark Nelson", "Dr. Angela Carter", "Dr. Brian Mitchell"],
  Pediatricians: ["Dr. Melissa Perez", "Dr. Eric Roberts", "Dr. Deborah Turner", "Dr. Jason Phillips", "Dr. Rebecca Campbell", "Dr. Andrew Parker"],
  AnaesthesiaSpecialists: ["Dr. Anil Mehta", "Dr. Priya Iyer", "Dr. Rakesh Nair", "Dr. Neha Sharma", "Dr. Vivek Rao", "Dr. Aarti Desai"]
};

export const doctorOptions = Object.values(doctorGroups).flat().sort();

export const observerGroups = ["Ethics Committee", "Medical Board", "Hospital Administration", "External Reviewers"];

export const signatureDatetimeMap = {
  patient_signature: "patient_signature_date_time",
  witness_signature: "witness_signature_date_time",
  doctor_anaesthetist_signature: "doctor_anaesthetist_signature_date_time",
  interpreter_signature: "interpreter_signature_date_time",
  patient_rep_signature: "patient_rep_signature_date_time",
  patient_rep_witness_signature: "patient_rep_witness_date_time",
  patient_rep_doctor_signature: "patient_rep_doctor_signature_date_time",
  patient_rep_interpreter_signature: "patient_rep_interpreter_signature_date_time"
};
